import {useProjectSelection} from './useProjectSelection'

export const useSelectedProject = () => {
  const {projects} = useProjectSelection()
  const project = projects.length === 1 ? projects[0] : undefined
  return {
    projectId: project?.id ?? null,
    projectName: project?.projectName,
    projectNumber: project?.projectNumber,
    isMock: project?.isMock,
    isArchived: project?.isArchived,
  }
}
